declare let mxPoint: any;
import * as mu from './cell-move.util';
import * as _ from 'lodash';

interface TranslationCoords {
  dx: number;
  dy: number;
}

function translateEdgesUtil(graph, cells, moving: TranslationCoords, resizing: TranslationCoords) {
  const model = graph.model;
  const {dx = 0, dy = 0} = moving ?? {};
  const {dx: rdx = 0, dy: rdy = 0} = resizing ?? {};

  if (cells != null) {
    cells = _.filter(cells, function (cell) {
      return !cell.edge;
    });

    const edges = [];
    const srcAlignEdges = [];
    const tgtAlignEdges = [];

    cells.forEach(function (cell) {
      if (cell.edges) {
        cell.edges.forEach(function (edge) {
          if (edges.indexOf(edge) < 0) {
            edges.push(edge);

            if (edge.source && +edge.source.id === +cell.id) {
              srcAlignEdges.push(edge);
            }

            if (edge.target && +edge.target.id === +cell.id) {
              tgtAlignEdges.push(edge);
            }
          }
        });
      }
    });

    edges.forEach(function (edge) {
      let absX, absY, wp, moveDirection, eDirection, resetCheck, newWp;
      let geo = model.getGeometry(edge);

      if (
        edge.target &&
        edge.source &&
        cells.indexOf(edge.target) >= 0 &&
        cells.indexOf(edge.source) >= 0
      ) {
        if (geo != null && geo.points != null && geo.points.length > 0) {
          geo = geo.clone();
          geo.points = mu.translateWaypoints(geo.points, dx, dy);
          model.setGeometry(edge, geo);
        }
      } else if (
        edge.target &&
        edge.source &&
        (cells.indexOf(edge.target) >= 0 || cells.indexOf(edge.source) < 0)
      ) {
        if (geo != null && geo.points != null && geo.points.length > 0) {
          const entryX = graph.getCellStyle(edge).entryX;
          const entryY = graph.getCellStyle(edge).entryY;

          absX = edge.target.geometry.width * entryX + edge.target.geometry.x;
          absY = edge.target.geometry.height * entryY + edge.target.geometry.y;

          wp = geo.points[geo.points.length - 1];
          moveDirection = mu.moveDirection(dx || rdx, dy || rdy);
          eDirection = mu.eDirection(entryX, entryY);
          resetCheck = mu.needReset(
            absX,
            absY,
            geo.points,
            moveDirection,
            eDirection,
            edge.target.geometry,
            false
          );

          if (resetCheck) {
            graph.resetEdge(edge);
          } else {
            if (mu.isHorizontal(moveDirection) && mu.isVertical(eDirection)) {
              newWp = wp.clone();
              geo = geo.clone();
              newWp.x = absX;
              geo.points[geo.points.length - 1] = newWp;
              model.setGeometry(edge, geo);
            } else if (mu.isVertical(moveDirection) && mu.isHorizontal(eDirection)) {
              newWp = wp.clone();
              geo = geo.clone();
              newWp.y = absY;
              geo.points[geo.points.length - 1] = newWp;
              model.setGeometry(edge, geo);
            }
          }
        }
      } else if (
        edge.target &&
        edge.source &&
        (cells.indexOf(edge.target) < 0 || cells.indexOf(edge.source) >= 0)
      ) {
        if (geo != null && geo.points != null && geo.points.length > 0) {
          const exitX = graph.getCellStyle(edge).exitX;
          const exitY = graph.getCellStyle(edge).exitY;

          absX = edge.source.geometry.width * exitX + edge.source.geometry.x;
          absY = edge.source.geometry.height * exitY + edge.source.geometry.y;

          wp = geo.points[0];
          moveDirection = mu.moveDirection(dx || rdx, dy || rdy);
          eDirection = mu.eDirection(exitX, exitY);
          resetCheck = mu.needReset(
            absX,
            absY,
            geo.points,
            moveDirection,
            eDirection,
            edge.source.geometry,
            true
          );

          if (resetCheck) {
            graph.resetEdge(edge);
          } else {
            if (mu.isHorizontal(moveDirection) && mu.isVertical(eDirection)) {
              newWp = wp.clone();
              geo = geo.clone();
              newWp.x = absX;
              geo.points[0] = newWp;
              model.setGeometry(edge, geo);
            } else if (mu.isVertical(moveDirection) && mu.isHorizontal(eDirection)) {
              newWp = wp.clone();
              geo = geo.clone();
              newWp.y = absY;
              geo.points[0] = newWp;
              model.setGeometry(edge, geo);
            }
          }
        }
      } else if ((!edge.target && edge.source) || (!edge.source && edge.target)) {
        const ePointX = !edge.target
          ? graph.getCellStyle(edge).exitX
          : graph.getCellStyle(edge).entryX;
        const ePointY = !edge.target
          ? graph.getCellStyle(edge).exitY
          : graph.getCellStyle(edge).entryY;
        const ddx = rdx * ePointX + dx;
        const ddy = rdy * ePointY + dy;
        let point = !edge.target ? geo.targetPoint : geo.sourcePoint;

        geo = geo.clone();
        geo.points = mu.translateWaypoints(geo.points, ddx, ddy);
        point = new mxPoint(point.x + ddx, point.y + ddy);
        geo.setTerminalPoint(point, !!edge.target);
        model.setGeometry(edge, geo);
      }
    });

    return {srcAlignEdges, tgtAlignEdges};
  }
}

export {translateEdgesUtil};
